import apiBaseState from "~/constants/apiBaseState";
import Vueset from "~/utils/Vueset";
const getState = () => {
    return {
        getMeetingRoomState: apiBaseState(),
        getMeetingRoomsState: apiBaseState(),
        createMeetingRoomState: apiBaseState(),
        getMeetingRoomPresenceState: apiBaseState(),
        updateMeetingRoomState: apiBaseState(),
        deleteMeetingRoomState: apiBaseState(),
        getUsersWithinTaskState: apiBaseState(),
        getUsersForMeetingRoomState: apiBaseState(),
        updateUsersForMeetingRoomState: apiBaseState(),
        toggleUserToMeetingRoomState: apiBaseState(),
    };
};

export const state = () => (getState());
export const mutations = {
    RESET_STORE(state){
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    RESET_MEETING_ROOM_PARTICIPANTS(state){
        const s = getState();
        state.getUsersWithinTaskState = s.getUsersWithinTaskState;
        state.getUsersForMeetingRoomState = s.getUsersForMeetingRoomState;
        state.updateUsersForMeetingRoomState = s.updateUsersForMeetingRoomState;
    },
    SET_GET_MEETING_ROOMS(state, payload){
        state.getMeetingRoomsState = payload;
    },
    SET_DELETE_MEETING_ROOM(state, payload){
        state.deleteMeetingRoomState = payload;
    },
    SET_GET_MEETING_ROOM(state, payload){
        state.getMeetingRoomState = payload;
    },
    SET_UPDATE_MEETING_ROOM(state, payload){
        state.updateMeetingRoomState = payload;
    },
    SET_CREATE_MEETING_ROOM(state, payload){
        state.createMeetingRoomState = payload;
    },
    SET_GET_MEETING_ROOM_PRESENCE(state, payload){
        state.getMeetingRoomPresenceState = payload;
    },
    ADD_TO_CREATE_MEETING_ROOM(state, payload){
        if(state.getMeetingRoomsState.data === null){
            state.getMeetingRoomsState.data = {
                data: []
            };
        }
        state.getMeetingRoomsState.data.data.unshift(payload);
    },
    SET_GET_USERS_WITHIN_TASK(state, payload){
        state.getUsersWithinTaskState = payload;
    },
    SET_GET_USERS_FOR_MEETING_ROOM(state, payload){
        state.getUsersForMeetingRoomState = payload;
    },
    DELETE_MEETING_ROOM_BY_ID(state, {id}){
        if(state.getMeetingRoomsState.data?.data.length){
            const index = state.getMeetingRoomsState.data.data.findIndex(item => item.id === id);
            state.getMeetingRoomsState.data.data.splice(index, 1);
        }
    },
    UPDATE_MEETING_ROOMS_BY_ID(state, room){
        if(state.getMeetingRoomsState.data?.data.length){
            const index = state.getMeetingRoomsState.data.data.findIndex(item => item.id === room.id);
            Vueset(state.getMeetingRoomsState.data.data, index, {
                ...room
            });
        }
    },
    SET_GET_USERS_FOR_MEETING_ROOM_DATA(state, {payload, meetingRoomId}){
        state.getUsersForMeetingRoomState.data = payload;
        const index = state.getMeetingRoomsState.data.data.findIndex(room => room.id === meetingRoomId);
        Vueset(state.getMeetingRoomsState.data.data, index, {
            ...state.getMeetingRoomsState.data.data[index],
            users: payload
        });
    },
    SET_TOGGLE_USER_TO_MEETING_ROOM(state, payload){
        state.toggleUserToMeetingRoomState = payload;
    },
    TOGGLE_USER_WITHIN_TASK_LOADING_STATE(state, {userId, loading, role}){
        const resultSet = role === 'participant'
            ? state.getUsersWithinTaskState.data.data
            : state.getUsersWithinTaskState.data.valid_hosts;

        const index = role === 'participant'
            ? resultSet.findIndex(user => user.user.id === userId)
            : resultSet.findIndex(user => user.id === userId);
        Vueset(resultSet, index, {
            ...resultSet[index],
            loading
        });

    },
};

export const actions = {
    GET_MEETING_ROOMS(state, data) {
        const {accountSlug, projectSlug, taskSlug, params} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms`;

        return this.$whyApi.get({
            url,
            params,
            mutation: "meetingRooms/SET_GET_MEETING_ROOMS",
            errorMessage: "Error getting meeting rooms",
            notify: this.$notify
        });
    },
    GET_MEETING_ROOM(state, data) {
        const {accountSlug, projectSlug, taskSlug, id} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms/${id}`;

        return this.$whyApi.get({
            url,
            mutation: "meetingRooms/SET_GET_MEETING_ROOM",
            errorMessage: "Error getting meeting room",
            notify: this.$notify
        });
    },
    GET_MEETING_ROOM_PRESENCE(state, data) {
        const {taskSlug, id} = data;
        const url = `/participant/task/${taskSlug}/rooms/${id}/presence`;

        return this.$whyApi.get({
            url,
            mutation: "meetingRooms/SET_GET_MEETING_ROOM_PRESENCE",
            errorMessage: "Error getting meeting room",
            notify: this.$notify
        });
    },
    DELETE_MEETING_ROOM(context, data) {
        const {accountSlug, projectSlug, taskSlug, id} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms/${id}`;

        return this.$whyApi.delete({
            url,
            mutation: "meetingRooms/SET_DELETE_MEETING_ROOM",
            errorMessage: "Error deleting meeting room",
            notify: this.$notify
        });
    },
    GET_USERS_WITHIN_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...params} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/users`;

        return this.$whyApi.get({
            url,
            params: {...params.params},
            isRefinementSearch: false,
            mutation: "meetingRooms/SET_GET_USERS_WITHIN_TASK",
            errorMessage: "Error getting users within task",
            notify: this.$notify
        });
    },
    GET_USERS_FOR_MEETING_ROOM(state, data) {
        const {accountSlug, projectSlug, taskSlug, id} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms/${id}/users`;

        return this.$whyApi.get({
            url,
            mutation: "meetingRooms/SET_GET_USERS_FOR_MEETING_ROOM",
            errorMessage: "Error getting users for meeting room",
            notify: this.$notify
        });
    },
    UPDATE_MEETING_ROOM(state, data) {
        const {accountSlug, projectSlug, taskSlug, id, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms/${id}`;

        return this.$whyApi.put({
            url,
            data: payload,
            mutation: "meetingRooms/SET_UPDATE_MEETING_ROOM",
            errorMessage: "Error updating meeting room",
            notify: this.$notify
        });
    },
    CREATE_MEETING_ROOM(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms`;

        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "meetingRooms/SET_CREATE_MEETING_ROOM",
            errorMessage: "Error creating meeting room",
            notify: this.$notify
        });
    },
    TOGGLE_USER_TO_MEETING_ROOM(state, data) {
        const {accountSlug, projectSlug, taskSlug, id, process, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/video-rooms/${id}/users/${process}`;

        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "meetingRooms/SET_TOGGLE_USER_TO_MEETING_ROOM",
            errorMessage: "Error managing user",
            notify: this.$notify
        });
    }
};
